import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { sslInfo } from '../../interface'
import useSWR, { trigger } from 'swr';
import { SettingAPI } from '../../../../../requests'
import { CERTIFICAT_STATUS, DEPLOY_STATUS } from '../../../../../utils/setting/domain'

interface DomainStatusProps {
  privateDomain?: string,
  domainSource: string,
}

interface Response<T> {
  code: number,
  data?: T,
  msg: string
}

const clsPrefix = 'cnn-domainstatus';
const DomainStatus: React.FC<DomainStatusProps> = ({
  privateDomain,
  domainSource,
}) =>{
  const [certificateLoad, setCertificateLoad] = useState(false);
  const [deployLoad, setDeployLoad] = useState(false);
  const sslStatusUrl = `/platform/kz_ssl/privateDomain/deployStatus`
  const sslStatusQuery = `domainStr=${privateDomain}&certificateOrigin=${domainSource}`
  const { data } = useSWR<Response<sslInfo>>([sslStatusUrl, sslStatusQuery], (url, query) => (
    fetch(url + '?' + query).then(res => res.json())
  ), {refreshInterval: 10000})

  // TODO 寻找更好的兼容方式
  const { 
    deployStatus, 
    depDefeatReason, 
    cerDefeatReason, 
    certificateStatus,
    certificateKey,
    certificatePem,
  } = (data && data.data)?  data.data : { deployStatus:'', depDefeatReason:'', cerDefeatReason:'',certificateStatus:'',certificateKey:'',certificatePem:''}

  useEffect(() => {
    if(domainSource === 'HELPER' && 
    getCookie('candeploy') !== 'false' && 
      certificateStatus === 'APPLY_SUCCESS'
      ) {
        setCookie('candeploy', 'true', new Date().toUTCString())
    }
  }, [certificateStatus,deployStatus])

  function setCookie (name: string, value: string, expires:string) {
    document.cookie = `${name}=${value};expires=${expires}`
  }

  function getCookie (name: string){
    const cookieArr = document.cookie.split(';')
    const valueArr = cookieArr.filter(item => item.indexOf(name) !== -1);
    return valueArr[0] && valueArr[0].split('=')[1]
  }

  async function handleCertificateTry() {
    setCertificateLoad(true)
    if (domainSource === 'HELPER' && getCookie('candeploy') !== 'false') {
      SettingAPI.applyCertificate({domainStr: privateDomain}).then((res:any) => {
        const time = new Date()
        time.setTime(time.getTime() + 3*60*1000)
        setCookie('candeploy','false',time.toUTCString())
      })
    } else if(domainSource === 'HELPER' && getCookie('candeploy') === 'false') {
      message.warn('正在申请中，请稍候。。。')
    } else if(domainSource === 'OWNER'){
      await SettingAPI.selfDeployCertificate({
        privateKey: certificateKey,
        certificateContent: certificatePem,
        domainStr: privateDomain,
      })
    }
    trigger(sslStatusUrl)
    setCertificateLoad(false)
  }

  async function handleDeployTry() {
    setDeployLoad(true)
    try {
      if(domainSource === 'HELPER') {
        const result:any = await SettingAPI.helpDeployCertificate({domainStr: privateDomain})
        if(result.code && result.code !== 200 ){
          message.error(result.msg)
        }
      } else {
        const result:any = await SettingAPI.selfDeployCertificate({
          privateKey: certificateKey,
          certificateContent: certificatePem,
          domainStr: privateDomain,
        })
        if(result.code && result.code !== 200 ){
          message.error(result.msg)
        }
      }
      setDeployLoad(false)
    } catch(err) {
      console.warn(err)
      setDeployLoad(false)
    }
    trigger(sslStatusUrl)
  }

  return (
    <>
      {domainSource === 'HELPER' && 
        <div style={{marginBottom: '10px', display: 'flex'}}>
          <span style={{marginRight: '20px'}}>证书状态</span>
          <div style={{width: '780px'}}>
            <div>
              {certificateStatus && CERTIFICAT_STATUS[certificateStatus] &&
                <span 
                  style={CERTIFICAT_STATUS[certificateStatus].style}
                >
                  {CERTIFICAT_STATUS[certificateStatus].value}
                </span>
              }
              {(certificateStatus !== 'APPLY_SUCCESS' && 
                certificateStatus !== 'APPLYING') && 
                <Button 
                  style={{marginLeft:'10px'}} 
                  size="small" 
                  loading={certificateLoad} 
                  onClick={handleCertificateTry}
                >
                点击重试
                </Button>}
            </div>
            {(certificateStatus === 'APPLY_DEFEAT' &&  cerDefeatReason) && 
              <div style={CERTIFICAT_STATUS[certificateStatus].style}>
                {`原因：${cerDefeatReason}`}
              </div>
            }
          </div>
        </div>
      }
      {!(domainSource === 'OWNER' && !certificateKey) && 
        <div style={{marginBottom: '10px', display: 'flex'}}>
          <span style={{marginRight: '20px'}}>部署状态</span>
          <div style={{width: '780px'}}>
            <div>
              {deployStatus && DEPLOY_STATUS[deployStatus] &&
                <span style={DEPLOY_STATUS[deployStatus].style} >
                  {DEPLOY_STATUS[deployStatus].value}
                </span>
              }
              {(deployStatus !== 'DEPLOY_SUCCESS' && 
                deployStatus !== 'DEPLOYING') && 
                <Button 
                  style={{marginLeft:'10px'}} 
                  size="small" loading={deployLoad} 
                  onClick={handleDeployTry}
                >
                  {deployStatus === 'NOT_DEPLOY'? '点击部署' : '点击重试'}
                </Button>}
            </div>
            {(deployStatus === 'DEPLOY_DEFEAT' && depDefeatReason) && 
              <div style={DEPLOY_STATUS[deployStatus].style}>
                {`原因：${depDefeatReason}`}
              </div>
            }
          </div>
        </div>}
    </>
  )
}

export default DomainStatus